
export default {
  name: 'CarbonCreditsSpecs',
}
